<template>

  <button 
    type="button" 
		:disabled="buttonDisable"
		v-on:click="onSaveButtonClick" >
		<slot />
  </button>

</template>

<script>

export default {
  name: "TemplateButton",
  props: ['button_class'],
  components: {
  },
  data () {
    return {
      buttonDisable : false,
    }
  },
  methods: {
		onSaveButtonClick() {
      this.buttonDisable = true
      setTimeout(() => this.buttonDisable = false, 1000)
			this.$emit('click')
		}
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateButton.vue